import { useContext, useState } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { FireBaseContext } from "../../Context/FireBase";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import {
  deleteDoc,
  doc,
  setDoc,
  getDocs,
  getDoc,
  serverTimestamp,
  query,
  where,
  updateDoc,
} from "firebase/firestore";
import UpdateSubModel from "../UpdateSubModel/UpdateSubModel";
export default function SettingsBtn({ refCollection, rowId, row }) {
  const { dbID } = useParams();
  const ITEM_HEIGHT = 38;
  const [anchorEl, setAnchorEl] = useState(null);
  const { SubscribersDeletedRef, EventRefrence } = useContext(FireBaseContext);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const removeSubscriber = async (id) => {
    try {
      const docRef = doc(refCollection, id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const item = docSnap.data();

        swal({
          title: "Are you sure you want to delete this subscriber?",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then(async (willDelete) => {
          if (willDelete) {
            await deleteDoc(docRef);

            await setDoc(doc(SubscribersDeletedRef, id), {
              event: dbID,
              ID: id,
              timing: serverTimestamp(),
              ...item,
            });

            // ✅ calculate cost from this single subscriber
            const totalCost = item.CostperDelegate || 0;

            const eventRef = doc(EventRefrence, dbID);
            const dataEvent = await getDoc(eventRef);

            const total = (dataEvent.data()?.eventCost || 0) - totalCost;

            await updateDoc(eventRef, { eventCost: total });

            swal({ icon: "success", title: "Deleted Successfully!" });

            handleClose();
          }
        });
      } else {
        swal({
          title: "Error",
          text: "No subscriber found to delete.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error deleting document:", error);
      swal({
        title: "Error",
        text: "There was an issue deleting the subscriber.",
        icon: "error",
      });
    }
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "15ch",
          },
        }}
      >
        <MenuItem>
          <div className="d-flex justify-content-between align-items-center">
            <UpdateSubModel user={row} />
          </div>
        </MenuItem>
        <MenuItem onClick={() => removeSubscriber(rowId)}>
          <div className="d-flex justify-content-center align-items-center gap-2 ">
            <i className={`fa-solid fa-trash text-danger `}></i>
            <span className="w-75 text-danger">Delete</span>
          </div>
        </MenuItem>
      </Menu>
    </div>
  );
}
